<main id="not-found">
  <div class="container col-xl-4 text-justify">
    <h1>{{'error.page.not-found.title' | translate}}</h1>
    <p>
      {{'error.page.not-found.message' | translate}}
    </p>
    @if (partner === 'systems') {
      <p>
        <i class="fal fa-fw fa-phone me-2"></i> <a href="tel:+39 0471 180 18 18">+39 0471 180 18 18</a>
      </p>
      <p>
        <i class="fal fa-fw fa-at me-2"></i> <a href="mailto:service@systems.bz">service&#64;systems.bz</a>
      </p>
    }
    <a class="btn btn-primary btn-block mt-3" routerLink="/" [title]="'navigation.to-start' | translate">{{'navigation.to-start' | translate}}</a>
  </div>
</main>